<template>
    <div :class="['fleet-group']" v-show="fleet.isVisible">
        <div :class="['fleet-header', {'inactive': !isExpandable}]" @click="expand()">
            <span class="fleet-name" :class="{'is-fleet-too-long': fleet.name.length > 15 }" :data-fleet-name="fleet.name">{{ fleet.name }}</span>
            <div class="fleet-amount">({{ fleet.vehicles.length }})</div>
        </div>
        <div class="cars-list" v-if="isActive">
            <car v-for="vehicle in fleet.vehicles" v-show="vehicle.isVisible" :active="false" :vehicle="vehicle" v-bind:key="vehicle.id"></car>
        </div>
    </div>
</template>

<script>
import Car from './Car'
import _ from 'lodash'
import { VEHICLE_STATUS_NAME } from '../../../config/consts'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'Fleet',
    components: { Car },
    mounted () {
        this.isExpandable = 0 < this.fleet.vehicles.length
    },
    data () {
        return {
            isActive: false,
            isExpandable: false,
            cars: [],
            filteredCars: [],
            carsToDisplay: 1,
            numberOfVisibleVehicles: 1,
            carsSummary: {
                online: 0,
                offline: 0,
                sleep: 0,
                total: 0
            },
            carInterval: null,
            intervalTime: 60 * 1000,
            filters: [
                VEHICLE_STATUS_NAME.DRIVING,
                VEHICLE_STATUS_NAME.OFFLINE,
                VEHICLE_STATUS_NAME.SLEEP
            ]
        }
    },
    props: {
        fleet: {
            type: Object,
            required: true
        },
        expandedByParent: {
            type: Boolean,
            default: false
        },
        updateFleetsOverview: {
            type: Function,
            required: true,
        }
    },
    watch: {
        expandedByParent: {
            handler (newVal, oldVal) {
                if (null != oldVal) {
                    this.expand(true)
                }
            }
        }
    },
    methods: {
        ...mapActions({
            trackingSubscribeVehicle: 'trackingModule/subscribeTrackingVehicle',
            trackingUnsubscribeVehicle: 'trackingModule/unsubscribeTrackingVehicle',
        }),
        expand (isExpandedByParent = false) {
            if (isExpandedByParent) {
                this.isActive = this.expandedByParent
            } else {
                this.isActive = !this.isActive
                this.subscribeOrUnsubscribeFleet(this.isActive);
            }
        },
        subscribeOrUnsubscribeFleet(isActive) {
            if (isActive) {
                this.fleet.vehicles.forEach(vehicle => {
                    this.trackingSubscribeVehicle(vehicle)
                })
                this.updateFleetsOverview()
            } else {
                this.fleet.vehicles.forEach(vehicle => {
                    this.trackingUnsubscribeVehicle(vehicle)
                })
                this.updateFleetsOverview()
            }
        }
    }
}
</script>

<style scoped lang="scss">
.depth1 {
    border-left: 16px solid rgb(255, 255, 255);
    background: rgb(255, 255, 255);
}

.depth2 {
    border-left: 16px solid rgb(240, 240, 240);
    background: rgb(240, 240, 240);
}

.depth3 {
    border-left: 16px solid rgb(220, 220, 220);
    background: rgb(220, 220, 220);
}

.depth4 {
    border-left: 16px solid rgb(200, 200, 200);
    background: rgb(200, 200, 200);
}

.fleet-group {
    //border-left: 16px solid rgb(255, 255, 255);
    background: rgb(255, 255, 255);

    .fleet-header {
        color: $dark;
        display: flex;
        padding: 10px 40px 10px 15px;
        position: relative;
        cursor: pointer;

        &:hover {
            /*background: rgba($white, 0.9)*/
            opacity: 0.9;
        }

        &.inactive {
            /*background: #eaeaeae8;*/
            cursor: not-allowed;
            color: $danger;
        }

        .fleet-name {
            font-size: 14px;
            font-weight: bold;
        }

        .fleet-amount {
            margin-left: auto;
        }

        &::after {
            content: '';
            display: inline-block;
            background: url('../../../assets/icons/icon-arrow-up.svg');
            width: 10px;
            height: 10px;
            position: absolute;
            right: 20px;
            top: 16px;
        }
    }

    .cars-list {
        background: $dark;
    }

    .no-cars {
        background: $dark;
        text-align: center;
        font-weight: bold;
        padding: 10px 0;
    }
}
</style>
